// extracted by css-extract-rspack-plugin
export default {"scrollbarHide":"hT7BQHuVMcBbEMzb","contentWrapper":"E0hl06zBK1kciMnh"};